import cn from 'clsx'

import { ImageBox, NavLink, Button } from 'shared-components'

import BlockArrow from '../../images/blockArrow'

import s from './BlogTile.module.sass'

function BlogTile({ post }: any) {
    const { title, slug, featuredImage, excerpt, category } = post

    const _excerpt = excerpt?.length > 200 ? `${excerpt.substring(0, 200)}...` : excerpt

    return (
        <div className={s.BlogTile}>
            <div>
                <NavLink href={`/news/${slug}`} className={s.Link}>
                    <div className={s.Image}>
                        {category && (
                            <div className={s.Category}>
                                <Button title={category?.name} noArrow small inverted noBorder />
                            </div>
                        )}
                        {featuredImage && <ImageBox image={featuredImage} width={500} height={500} />}
                    </div>
                    <div className={s.Content}>
                        <div className={s.Title}>
                            <h5>{title}</h5>
                            {BlockArrow}
                        </div>
                        {_excerpt && (
                            <div
                                className={cn(s.Excerpt, 'copy small')}
                                dangerouslySetInnerHTML={{ __html: _excerpt }}
                            />
                        )}
                    </div>
                </NavLink>
            </div>
        </div>
    )
}

export default BlogTile
